import { render } from "./App.vue?vue&type=template&id=40b5fe59"
const script = {}

import "./App.vue?vue&type=style&index=0&id=40b5fe59&lang=css"

import exportComponent from "D:\\workspace\\viglacera\\nhathau\\fe\\source005\\vig_contructor_fe_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__